import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaterialStone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "material-stone" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.211,23.25,21.164,2.1A1.5,1.5,0,0,0,19.672.75H4.328A1.5,1.5,0,0,0,2.836,2.1L.789,23.25Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 1.515,
			y1: 15.75,
			x2: 22.485,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.229,
			y1: 8.25,
			x2: 21.759,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.036,
			y1: 8.25,
			x2: 12.036,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.786,
			y1: 15.75,
			x2: 17.286,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.786,
			y1: .75,
			x2: 16.286,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.286,
			y1: 15.75,
			x2: 6.786,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.286,
			y1: .75,
			x2: 7.786,
			y2: 8.25
		})
	]
});
export default SvgMaterialStone;
